export default __webpack_public_path__ + "static/media/5star-shiny-hr.90e91a35.png";